export default "__VITE_ASSET__DnlVTje___"